<ngx-spinner name="dialogSpinner" [fullScreen]="false" type="ball-clip-rotate-multiple" size="medium">
    <p style="color: white">Loading ...</p>
</ngx-spinner>
<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div ngbRadioGroup name="adB2CUsers" [(ngModel)]="selectedAdB2CUserId">
        <div style="padding: 2px;" *ngFor="let adB2CUser of adB2CUsers">
            <div class="btn-group-lg btn-group btn-group-toggle">
                <label ngbButtonLabel class="btn-focus">
                    <input ngbButton type="radio" [value]="adB2CUser.id">
                    <div>{{adB2CUser.name}}</div>                    
                </label>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button [disabled]="!selectedAdB2CUserId" type="button" class="btn btn-secondary"
        (click)="onAccept(selectedAdB2CUserId)">Accept</button>
    <button type="button" class="btn btn-secondary" (click)="onDismiss()">Cancel</button>
</div>